<template>
    <div class="passwordBlock">
        <input :type="type" v-model="input" class="wideField password" :disabled="props.disabledMode" autocomplete="new-password" />
        <button type="button" class="btnPassword" @click="change">&nbsp;</button>
    </div>
</template>

<style></style>

<script setup>
    import { defineModel, ref, defineProps } from 'vue';
    import { defineExpose } from 'vue';

    const INPUT_TYPE_TEXT = 'text';
    const INPUT_TYPE_PASSWORD = 'password';

    const input = defineModel('input');
    const type = ref(INPUT_TYPE_PASSWORD);

    /**
     * 親画面から実行を許可する本コンポーネント内のメソッドの一覧。
     */
     defineExpose({
        resetInput,
    });

    // InputのHTML要素を初期化する。
    async function resetInput() {
        // パスワード入力欄のHTMLの型の初期値はpassword型にする。
        type.value = INPUT_TYPE_PASSWORD;
    }

    function change() {
        if (type.value === INPUT_TYPE_PASSWORD) {
            type.value = INPUT_TYPE_TEXT;
        } else {
            type.value = INPUT_TYPE_PASSWORD;
        }
    }

    // ----------------------------
    // Props
    // ----------------------------
    const props = defineProps({
        // パスワード入力欄を非活性にする場合がある。
        disabledMode: {
            type: Boolean,
            default: false,
        },
    });
</script>
